import { useEffect } from 'react'
import Layout from './pages/layout/Layout'
import * as Tooltip from '@radix-ui/react-tooltip'
import { DarkModeProvider } from './contexts/DarkModeContext'
import './index.css'
import './theme/variables.css'
import 'react-image-crop/dist/ReactCrop.css'
import { watchCaptureCloses } from './api/pendingCaptureCloses'

const LayoutWrapper = () => {
    // A capture's End that did not get through, sent again from any page.
    useEffect(() => watchCaptureCloses(), [])

    return (
        <DarkModeProvider>
            <Tooltip.Provider>
                <Layout />
            </Tooltip.Provider>
        </DarkModeProvider>
    )
}

export default LayoutWrapper
